import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8e75f64e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "col-md-4" }
const _hoisted_2 = { class: "mb-3" }
const _hoisted_3 = { class: "scroll" }
const _hoisted_4 = { class: "col-md-4" }
const _hoisted_5 = { class: "col-md-6 underline" }
const _hoisted_6 = { class: "mt-3" }
const _hoisted_7 = { class: "col-md-6 underline" }
const _hoisted_8 = { class: "row left middle" }
const _hoisted_9 = { class: "col-md-9" }
const _hoisted_10 = ["id"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "null" }, "None", -1))
const _hoisted_12 = ["value"]
const _hoisted_13 = { class: "col-md-3" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "row left middle" }
const _hoisted_16 = { class: "col-md-9" }
const _hoisted_17 = { class: "col-md-3" }
const _hoisted_18 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("button", {
            class: "btn m-2 btn-primary",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args)))
          }, " Save ")
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.orderStatuses, (os) => {
          return (_openBlock(), _createElementBlock("div", {
            key: 'orderstatus_'+os.Id,
            class: "row left"
          }, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, _toDisplayString(os.Name), 1)
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("select", {
                      id: `Type_${os.Id}`,
                      class: "form-select"
                    }, [
                      _hoisted_11,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filterStatus(os.Id), (item) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: item.Id,
                          value: item.Id
                        }, _toDisplayString(item.Name), 9, _hoisted_12))
                      }), 128))
                    ], 8, _hoisted_10)
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("button", {
                      class: "btn m-2 btn-primary",
                      onClick: ($event: any) => (_ctx.addVal(os.Id, `Type_${os.Id}`))
                    }, " Add ", 8, _hoisted_14)
                  ])
                ])
              ]),
              (_ctx.model[os.Id])
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.model[os.Id], (statusId) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: 'status_'+statusId
                    }, [
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.GetName(statusId)), 1),
                        _createElementVNode("div", _hoisted_17, [
                          _createElementVNode("button", {
                            class: "btn m-2 btn-primary",
                            onClick: ($event: any) => (_ctx.RemoveStatus(os.Id, statusId))
                          }, " Remove ", 8, _hoisted_18)
                        ])
                      ])
                    ]))
                  }), 128))
                : _createCommentVNode("", true)
            ])
          ]))
        }), 128))
      ])
    ])
  ], 64))
}